import { apiClient } from '@/api/client'
import type { LoginResponse, SessionResponse } from './types'

export async function fetchSession(): Promise<SessionResponse> {
  const { data } = await apiClient.get<SessionResponse>('/v2/auth/session')
  return data
}

export async function login(email: string, password: string, recaptchaToken: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/v2/auth/api-login', {
    email,
    password,
    recaptcha_token: recaptchaToken,
  })
  return data
}

export async function signup(fields: {
  firstname: string
  lastname: string
  email: string
  password: string
  phone: string
  recaptchaToken: string
}): Promise<{ message: string }> {
  const { recaptchaToken, ...rest } = fields
  const { data } = await apiClient.post<{ message: string }>('/v2/auth/api-signup', {
    ...rest,
    recaptcha_token: recaptchaToken,
  })
  return data
}

export async function logout(): Promise<void> {
  await apiClient.get('/v2/auth/logout')
}

export async function requestPasswordReset(email: string): Promise<{ status: string; message: string }> {
  const { data } = await apiClient.post<{ status: string; message: string }>('/v2/auth/reset-password', {
    email,
  })
  return data
}

export async function validateResetToken(
  token: string,
): Promise<{ valid: boolean; email?: string; message?: string }> {
  const { data } = await apiClient.get<{ valid: boolean; email?: string; message?: string }>(
    `/v2/auth/reset-password/${token}`,
  )
  return data
}

export async function submitPasswordReset(
  token: string,
  password1: string,
  password2: string,
): Promise<{ status: string; message: string }> {
  const { data } = await apiClient.post<{ status: string; message: string }>(
    `/v2/auth/reset-password/${token}`,
    { password1, password2 },
  )
  return data
}
